import { render } from "./CustomerGroupList.vue?vue&type=template&id=26be2b70"
import script from "./CustomerGroupList.vue?vue&type=script&lang=js"
export * from "./CustomerGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__